export enum GlobalProductsRoutes {
  BASE = 'c',
  BASE_REGEX = '^(c|sc|sec)-',
  BASE_CATEGORY_PAGE = 'products'
}
